require('./payrollLoanRequestStepOne.scss');
require('./payrollLoanRequestStepOne.override.scss');

const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { downloadAsFile } = require('utilities/APIRequestHelper');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @commons
const OKCalculationWaffer = require('components/commons/OKCalculationWaffer/OKCalculationWaffer');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const ContractLoanSliders = require('../../../contractLoanSliders/contractLoanSliders');
const PayrollLoanGridImages = require('../../../contractPayrollLoan/payrollLoanGridImages/payrollLoanGridImages');
const PayrollLoanRequestIncomeModal = require('../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestIncomeModal/payrollLoanRequestIncomeModal');
const PayrollLoanRequestOutcome = require('../payrollLoanRequestOutcomeModal/payrollLoanRequestOutcome');
const PayrollLoanRequestLaboralStatus = require('../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestLaboralStatus/payrollLoanRequestLaboralStatus');
const PayrollLoanRequestWorkingTime = require('../../../contractPayrollLoan/payrollLoanRequest/payrollLoanRequestWorkingTime/payrollLoanRequestWorkingTime');

// @constants
const { PERCENTAGE_SYMBOL } = require('constants/index');
const { LOAN_CHECK_CIRBE_PERSONAL } = require('constants/flagBasedFeatures');
const {
    payrollLoanHouseRegime: {
        PAYROLL_LOAN_HOUSE_REGIME_RENTED_PROPERTY,
        PAYROLL_LOAN_HOUSE_REGIME_FAMILY_PROPERTY,
        PAYROLL_LOAN_HOUSE_REGIME_MORTGAGED_PROPERTY,
        PAYROLL_LOAN_HOUSE_REGIME_TAXLESS_PROPERTY,
        PAYROLL_LOAN_HOUSE_REGIME_OTHER,
    },
    payrollLoanCivilStatus: {
        PAYROLL_LOAN_CIVIL_STATUS_MARRIED,
        PAYROLL_LOAN_CIVIL_STATUS_DIVORCED,
        PAYROLL_LOAN_CIVIL_STATUS_SEPARATED,
        PAYROLL_LOAN_CIVIL_STATUS_SINGLE,
        PAYROLL_LOAN_CIVIL_STATUS_WIDOWED,
    },
    PAYROLL_LOAN_DATA_PROTECTION_DOCUMENT_LINK
} = require('../../../../../loansConstants/index');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @helpers
const { formatAmount, formatCurrency, getFormattedString } = require('utilities/currencyHelper');
const {
    showWorkingTimeSection,
} = require('../../../../../loansUtilities/loansHelper');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');

class PayrollLoanRequestStepOne extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            incomeIsOpen: false,
        };

        this.handleAcceptIncomeModal = this.handleAcceptIncomeModal.bind(this);
        this.handleToggleIncomeModal = this.handleToggleIncomeModal.bind(this);
        this.handleAcceptOutcomeModal = this.handleAcceptOutcomeModal.bind(this);
        this.handleDownloadDocuments = this.handleDownloadDocuments.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
    }

    componentWillMount() {
        const { resetMinTermMaxAmount } = this.props;
        resetMinTermMaxAmount();
    }

    componentDidMount() {
        const {
            initialize,
            isDragoFeature,
            getPersonalInformation,
            resetCheckboxCirbe,
            simulationToken,
        } = this.props;
        initialize(simulationToken, isDragoFeature);
        resetCheckboxCirbe();
        if (isDragoFeature) {
            getPersonalInformation();
        }
    }

    handleDownloadDocuments(filename = 'Proteccion_datos_prestamo.pdf') {
        fetch(PAYROLL_LOAN_DATA_PROTECTION_DOCUMENT_LINK)
            .then(res => res.blob())
            .then(blobFile => {
                downloadAsFile(blobFile, 'application/pdf', filename);
            })
    }

    getCreditCards() {
        return [
            { value: 0, label: 0 },
            { value: 1, label: 1 },
            { value: 2, label: 2 },
            { value: 3, label: formatText('payrollLoanRequestStepOne-threeOrMore') },
        ];
    }

    getSelectValues(list) {
        return list.map((item, index) => {
            return { value: index, label: formatText('payrollLoanRequestStepOne-' + item) }
        });
    }

    addPercentage(value) {
        return formatAmount(value, 2).concat(' ', PERCENTAGE_SYMBOL);
    }

    buildCards() {
        const { setPurpose, immContractLoan, isDragoFeature } = this.props;
        return (
            <PayrollLoanGridImages
                immContractLoan={immContractLoan}
                isDragoFeature={isDragoFeature}
                setPurpose={setPurpose}
                validate={immContractLoan.get('validate')}
                required
            />
        );
    }

    buildSubpurpose(subpurposeList) {
        const { formHandlers, immContractLoan } = this.props;

        const value = immContractLoan.get('subpurposeDrago');
        const validate = immContractLoan.get('validate');

        const error = !value && validate ? (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_subPurposeError"
            />
        ) : null;

        return (
            <React.Fragment>
                <div className="col-xs-6 payroll-loan-request-step-one__container-without-left">
                    <OKSelect
                        label="payrollLoanRequestStepOne-payrollLoanRequestStepOne_subPurposeTitle"
                        name="subpurpose-select"
                        options={subpurposeList.toJS()}
                        searchable={false}
                        errorState={!!error}
                        onChange={formHandlers.handleSubpurposeChange}
                        value={value}
                    />
                </div>
                <div className="col-xs-12 payroll-loan-request-step-one__container-without-left">
                    {error}
                </div>
            </React.Fragment>
        );
    }

    buildCivilStatus() {
        const {
            immContractLoan,
            isDragoFeature,
            formHandlers,
        } = this.props;
        const value = isDragoFeature ? immContractLoan.get('maritalStatusDrago') : immContractLoan.get('civilStatus');
        const validate = immContractLoan.get('validate');

        const maritalStatusList = immContractLoan.get('maritalStatusList');
        let civilStatusesOptions = maritalStatusList.size ? maritalStatusList.toJS() : maritalStatusList.toArray();
        let typeCivilStatus = "maritalStatusDrago";

        if (!isDragoFeature) {
            typeCivilStatus = "civilStatus";
            civilStatusesOptions = [
                {
                    label: formatText('payrollLoanRequestStepOne-married'),
                    value: PAYROLL_LOAN_CIVIL_STATUS_MARRIED
                },
                {
                    label: formatText('payrollLoanRequestStepOne-divorced'),
                    value: PAYROLL_LOAN_CIVIL_STATUS_DIVORCED
                },
                {
                    label: formatText('payrollLoanRequestStepOne-separated'),
                    value: PAYROLL_LOAN_CIVIL_STATUS_SEPARATED
                },
                {
                    label: formatText('payrollLoanRequestStepOne-single'),
                    value: PAYROLL_LOAN_CIVIL_STATUS_SINGLE
                },
                {
                    label: formatText('payrollLoanRequestStepOne-widower'),
                    value: PAYROLL_LOAN_CIVIL_STATUS_WIDOWED
                },
            ];
        }


        const error = !value && validate ? (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value="payrollLoanRequestStepOne-civilStatusError"
            />
        ) : null;

        const classNameContainer = classNames('payroll-loan-request-step-one__input-fields__select', {
            'row': !isDragoFeature,
        });

        return (
            <div className={classNameContainer}>
                <div className="col-xs-6">
                    <OKSelect
                        label="payrollLoanRequestStepOne-civilStatus"
                        name="civil-status-select"
                        errorState={!!error}
                        options={civilStatusesOptions}
                        searchable={false}
                        onChange={result => formHandlers.handleCivilStatusChange(typeCivilStatus, result)}
                        value={value}
                    />
                </div>
                <div className="col-xs-12">
                    {error}
                </div>
            </div>
        );
    }

    buildCreditCards() {
        const {
            immContractLoan,
            isDragoFeature,
            formHandlers
        } = this.props;

        const titleField = isDragoFeature ? "payrollLoanRequestStepOne-payrollLoanRequestStepOne_titleCreditCardsField" :
            "payrollLoanRequestStepOne-creditCards";
        const errorText = isDragoFeature ? "payrollLoanRequestStepOne-payrollLoanRequestStepOne_creditCardsError" :
            "payrollLoanRequestStepOne-creditCardsError";

        const creditCardOptions = this.getCreditCards();
        const value = immContractLoan.get('creditCards');
        const validate = immContractLoan.get('validate');

        const error = !value && value !== 0 && validate ? (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value={errorText}
            />
        ) : null;

        const classNameContainer = classNames({
            'row payroll-loan-request-step-one__container-credit-card': !isDragoFeature,
            'col-xs-8 payroll-loan-request-step-one__input-fields__select': isDragoFeature
        });

        return (
            <div className={classNameContainer}>
                {isDragoFeature &&
                    <FormattedText
                        value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_titleCreditCardsSection"
                        className="payroll-loan-request-step-one__title-fields"
                    />
                }
                <FormattedText
                    className="payroll-loan-request-step-one__input-fields__senior-label"
                    value={titleField}
                />
                <div className="col-xs-6 payroll-loan-request-step-one__container-without-left">
                    <OKSelect
                        name="credit-card-select"
                        options={creditCardOptions}
                        errorState={!!error}
                        searchable={false}
                        onChange={formHandlers.handleCreditCardChange}
                        value={value}
                    />
                </div>
                <div className="col-xs-12 payroll-loan-request-step-one__container-without-left">
                    {error}
                </div>
            </div>
        );
    }

    buildOutcome() {
        const {
            formHandlers,
            getLoansForExpenses,
            immContractLoan,
            isDragoFeature,
        } = this.props;

        return (
            <PayrollLoanRequestOutcome
                className="payroll-loan-request-step-one__outcome-section col-xs-12"
                formHandlers={formHandlers}
                getLoansForExpenses={getLoansForExpenses}
                immContractLoan={immContractLoan}
                isDragoFeature={isDragoFeature}
                onAccept={this.handleAcceptOutcomeModal}
            />
        );
    }

    buildTitleCompleteData() {
        return (
            <div className="col-xs-12">
                <div className="payroll-loan-request-step-one__title-complete-data">
                    <FormattedText value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_titleCompleteAllData" />
                </div>
            </div>
        );
    }

    buildTitlePersonalData() {
        return (
            <div className="col-xs-12">
                <div className="payroll-loan-request-step-one__input-fields__title">
                    <FormattedText value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_titlePersonalData" />
                </div>
            </div>
        );
    }

    buildWorkingTimeSection() {
        const {
            formHandlers,
            immContractLoan,
            isDragoFeature,
        } = this.props;

        return showWorkingTimeSection(immContractLoan.get('newJobType')) ? (
            <PayrollLoanRequestWorkingTime
                formHandlers={formHandlers}
                immContractLoan={immContractLoan}
                isDragoFeature={isDragoFeature}
            />
        ) : null;
    }

    buildInputFields() {
        const {
            formHandlers,
            immContractLoan,
            immFlagBasedFeatures,
            isDragoFeature,
            setCirbeCheck,
        } = this.props;
        const { incomeIsOpen } = this.state;

        const monthlyOutcome = this.buildOutcome();
        const regime = this.buildRegime();
        const civilStatus = this.buildCivilStatus();
        const creditCards = this.buildCreditCards();
        const labelCheckbox = <FormattedText value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_labelCirbeCheckbox" />;
        const isActiveCheckboxCirbe = immFlagBasedFeatures.get(LOAN_CHECK_CIRBE_PERSONAL);
        const titleIncomesSection = isDragoFeature ? 'payrollLoanRequestStepOne-payrollLoanRequestStepOne_titleIncomesSection' :
            'payrollLoanRequestStepOne-inputFieldsTitle';
        const titleCompleteData = isDragoFeature ? this.buildTitleCompleteData() : null;
        const titlePersonalData = isDragoFeature ? this.buildTitlePersonalData() : null;
        const workingTimeSection = this.buildWorkingTimeSection();

        const monthlyIncome = (
            <PayrollLoanRequestIncomeModal
                className="col-xs-12"
                onAccept={this.handleAcceptIncomeModal}
                onToggle={this.handleToggleIncomeModal}
                immContractLoan={immContractLoan}
                immIncome={immContractLoan.get('income')}
                isDragoFeature={isDragoFeature}
                isOpen={incomeIsOpen}
                validate={immContractLoan.get('validate')}
            />
        );

        const classNameContainerTitle = classNames('col-xs-12', {
            'payroll-loan-request-step-one__container-title': isDragoFeature,
        });

        return (
            <div className="payroll-loan-request-step-one__input-fields">
                <div className="row">
                    {titleCompleteData}
                    {titlePersonalData}
                    {isDragoFeature && civilStatus}
                    {isDragoFeature && regime}
                    <div className={classNameContainerTitle}>
                        <div className="payroll-loan-request-step-one__input-fields__title">
                            <FormattedText value={titleIncomesSection} />
                        </div>
                    </div>
                    {monthlyIncome}
                    {monthlyOutcome}
                    {isDragoFeature && creditCards}
                    <PayrollLoanRequestLaboralStatus
                        formHandlers={formHandlers}
                        immContractLoan={immContractLoan}
                        isDragoFeature={isDragoFeature}
                    />
                    {workingTimeSection}
                </div>
                {!isDragoFeature && regime}
                {!isDragoFeature && civilStatus}
                {!isDragoFeature && creditCards}
                {isActiveCheckboxCirbe &&
                    <OKCheckbox
                        idName="payroll-loan-request-step-one-checkbox-cirbe"
                        extraClass="payroll-loan-request-step-one__checkbox-cirbe"
                        label={labelCheckbox}
                        onChange={setCirbeCheck}
                        value={immContractLoan.get('checkboxCirbe')}
                    />
                }
                <OKPdfViewer
                    pdfFile={PAYROLL_LOAN_DATA_PROTECTION_DOCUMENT_LINK}
                    title={formatText("gdprNominaLoan-title")}
                    onDownload={this.handleDownloadDocuments}
                    onPrint={this.handleOnPrint}
                    showScroll={true}
                    viewerHeight={450}
                />
            </div>
        );
    }

    buildRegime() {
        const {
            immContractLoan,
            isDragoFeature,
            formHandlers,
        } = this.props;
        const value = isDragoFeature ? immContractLoan.get('housingTypeDrago') : immContractLoan.get('regime');
        const validate = immContractLoan.get('validate');

        const housingRegimeList = immContractLoan.get('housingRegimeList');
        let regimeList = housingRegimeList.size ? housingRegimeList.toJS() : housingRegimeList.toArray();
        let typeRegime = "housingTypeDrago";

        if (!isDragoFeature) {
            typeRegime = "regime";
            regimeList = [
                {
                    label: formatText('payrollLoanRequestStepOne-rental'),
                    value: PAYROLL_LOAN_HOUSE_REGIME_RENTED_PROPERTY
                },
                {
                    label: formatText('payrollLoanRequestStepOne-family'),
                    value: PAYROLL_LOAN_HOUSE_REGIME_FAMILY_PROPERTY
                },
                {
                    label: formatText('payrollLoanRequestStepOne-mortgaged'),
                    value: PAYROLL_LOAN_HOUSE_REGIME_MORTGAGED_PROPERTY
                },
                {
                    label: formatText('payrollLoanRequestStepOne-loadProperty'),
                    value: PAYROLL_LOAN_HOUSE_REGIME_TAXLESS_PROPERTY
                },
                {
                    label: formatText('payrollLoanRequestStepOne-others'),
                    value: PAYROLL_LOAN_HOUSE_REGIME_OTHER
                }
            ];
        }

        const error = !value && validate ? (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value="payrollLoanRequestStepOne-regimeError"
            />
        ) : null;

        const classNameContainer = classNames('payroll-loan-request-step-one__input-fields__select', {
            'row': !isDragoFeature,
        });

        const classNameContainerSelect = classNames('col-xs-6', {
            'payroll-loan-request-step-one__container-select': isDragoFeature,
        });

        return (
            <div className={classNameContainer}>
                <div className={classNameContainerSelect}>
                    <OKSelect
                        label="payrollLoanRequestStepOne-regimeLabel"
                        name="regime-select"
                        errorState={!!error}
                        options={regimeList}
                        searchable={false}
                        onChange={result => formHandlers.handleRegimeChange(typeRegime, result)}
                        value={value}
                    />
                </div>
                <div className="col-xs-12">
                    {error}
                </div>
            </div>
        );
    }

    buildSliders() {
        const {
            getInstallment,
            immContractLoan,
            isDragoFeature,
            setLoanAmount,
            setLoanTerm,
        } = this.props;

        const amountTitle = isDragoFeature ? formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_sliderAmountTitle") : null;
        const termTitle = isDragoFeature ? formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_sliderTermTitle") : null;

        return (
            <React.Fragment>
                {isDragoFeature &&
                    <div className="col-xs-6 payroll-loan-request-step-one__container-title-sliders">
                        <FormattedText
                            value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_slidersTitle"
                            className="payroll-loan-request-step-one__title-sliders"
                        />
                    </div>
                }
                <ContractLoanSliders
                    amountTitle={amountTitle}
                    getInstallment={getInstallment}
                    immContractLoan={immContractLoan}
                    isCollective={!!immContractLoan.get('isCollective')}
                    setLoanAmount={setLoanAmount}
                    setLoanTerm={setLoanTerm}
                    termTitle={termTitle}
                    isDragoFeature={isDragoFeature}
                />
            </React.Fragment>
        )
    }

    buildTin() {
        const { immContractLoan } = this.props;
        const rawTin = immContractLoan.get('tin');
        const isCollective = immContractLoan.get('isCollective');
        let tinText = null;

        if (isCollective) {
            const collectiveTinRaw = immContractLoan.getIn(['collectiveInformation', '0', 'tin']);
            const collectiveTin = this.addPercentage(collectiveTinRaw);
            const tin = this.addPercentage(rawTin);
            tinText = (
                <span className="payroll-loan-request-step-one__waffer-item">
                    <span>
                        {collectiveTin}
                    </span>
                    <s>
                        <span>
                            {tin}
                        </span>
                    </s>
                </span>
            )
        } else {
            tinText = this.addPercentage(rawTin);
        }

        return tinText;
    }

    buildTae() {
        const { immContractLoan } = this.props;
        const isCollective = immContractLoan.get('isCollective');
        const rawTae = immContractLoan.get('tae');
        let taeText = null;

        if (isCollective) {
            const rawCollectiveTae = immContractLoan.getIn(['collectiveInformation', '0', 'tae']);
            const collectiveTae = this.addPercentage(rawCollectiveTae);
            const tae = this.addPercentage(rawTae);
            taeText = (
                <span className="payroll-loan-request-step-one__waffer-item">
                    <span>
                        {collectiveTae}
                    </span>
                    <s>
                        <span>
                            {tae}
                        </span>
                    </s>
                </span>
            )
        } else {
            taeText = this.addPercentage(rawTae);
        }

        return taeText;
    }

    buildFee() {
        const { immContractLoan } = this.props;
        const isCollective = immContractLoan.get('isCollective');
        const rawArrangementFee = immContractLoan.get('arrangementFee');
        const arrangementFee = formatAmount(rawArrangementFee);

        const rawCurrency = immContractLoan.get('currency');
        const currency = formatCurrency(rawCurrency);
        const feeText = `${arrangementFee} ${currency}`;
        let fee = null;

        if (isCollective) {
            fee = (
                <span className="payroll-loan-request-step-one__waffer-item">
                    <span>
                        {feeText}
                    </span>
                    <span>
                        &nbsp;
                    </span>
                </span>
            )
        } else {
            fee = feeText;
        }

        return fee;
    }

    buildInstallment() {
        const { immContractLoan } = this.props;
        const isCollective = immContractLoan.get('isCollective');
        const installment = getFormattedString(immContractLoan.get('installment'));
        const currency = immContractLoan.get('currency')
        let installmentText = null;

        if (isCollective) {
            const installmentCollectiveRaw = immContractLoan.getIn(['collectiveInformation', '0', 'installment']);
            const installmentCollective = getFormattedString({
                amount: installmentCollectiveRaw,
                currency
            });

            installmentText = (
                <span className="payroll-loan-request-step-one__strike-installment">
                    <span>{installmentCollective}</span>
                    <span>
                        <s>
                            {installment}
                        </s>
                    </span>
                </span>
            );
        } else {
            installmentText = installment;
        }

        return installmentText;
    }

    buildWaffer() {
        const { immContractLoan, taeTooltip } = this.props;
        const isCollective = immContractLoan.get('isCollective');
        const installment = this.buildInstallment();
        const isFetching = immContractLoan.get('isFetchingInstallment');

        const tin = this.buildTin();
        const tae = this.buildTae();
        const arrangementFee = this.buildFee();
        const className = isCollective ? 'payroll-loan-request-step-one__waffer-collective' : null;

        const values = [
            {
                title: formatText('payrollLoanRequestStepOne-anualTin'),
                bodyText: tin
            },
            {
                tooltipAlternativeIcon: true,
                title: formatText('payrollLoanRequestStepOne-TAE'),
                boldTitle: true,
                bodyText: tae,
                icon: 'icon-informacion',
                tooltipModifier: "dark-bg",
                tooltipPlacement: 'right',
                tooltipClassName: 'payroll-loan-request-step-one__tooltip',
                iconCustomClass: 'payroll-loan-request-step-one__tae-icon',
                tooltipOffset: [10, 0],
                information: taeTooltip,
                className: 'item-tae',
            },
            {
                title: formatText('payrollLoanRequestStepOne-arrangementFee', [immContractLoan.get('arrangementPercentage')]),
                additionalLabel: (<sup>1</sup>),
                bodyText: arrangementFee
            }
        ];

        return isFetching ? (
            <div className="payroll-loan-request-step-one__waffer-loading-wrapper">
                <LoadingSection />
            </div>
        ) :
            (
                <OKCalculationWaffer
                    className={className}
                    itemsList={values}
                    outstandedLabel={formatText('payrollLoanRequestStepOne-monthlyInstallment')}
                    outstandedText={installment}
                />
            );
    }

    handleAcceptIncomeModal(income) {
        const { formHandlers } = this.props;

        formHandlers.handleIncomeChange(income);

        this.handleToggleIncomeModal();
    }

    handleAcceptOutcomeModal(outcome) {
        const { formHandlers } = this.props;

        formHandlers.handleOutcomeChange(outcome);
    }

    handleToggleIncomeModal() {
        this.setState({ incomeIsOpen: !this.state.incomeIsOpen });
    }

    handleOnPrint() {
        fetch(PAYROLL_LOAN_DATA_PROTECTION_DOCUMENT_LINK)
            .then(res => res.blob())
            .then(blob => {
                const reader = new FileReader();
                reader.onload = () => {
                    const base64data = reader.result;
                    openBase64pdfInPrintWindow(base64data);
                };
                reader.readAsDataURL(blob);
            })
    }

    buildTitle() {
        const { immContractLoan } = this.props;
        const isCollective = immContractLoan.get('isCollective');

        return isCollective ? (
            <header className="payroll-loan-request-step-one__collective-header">
                <h4 className="payroll-loan-request-step-one__collective-title">
                    <FormattedText value="payrollLoanRequestStepOne-collectiveTitle" />
                </h4>
                <FormattedText value="payrollLoanRequestStepOne-collectiveSubtitle" />
            </header>
        ) : null;
    }

    render() {
        const { immContractLoan, isDragoFeature } = this.props;
        const title = this.buildTitle();
        const sliders = this.buildSliders();
        const inputFields = this.buildInputFields();
        const waffer = this.buildWaffer();
        const cards = this.buildCards();

        const selectedPurpose = immContractLoan.get('selectedPurposeDrago');
        const subpurposeList = immContractLoan.get('subpurposeList');
        const showSubPurposeElement = isDragoFeature && selectedPurpose && subpurposeList.size;
        const subpurpose = showSubPurposeElement ? this.buildSubpurpose(subpurposeList) : null;

        return immContractLoan.get('initialized') ? (
            <section className="payroll-loan-request-step-one">
                {title}
                {cards}
                {subpurpose}
                {sliders}
                {waffer}
                {inputFields}
            </section>
        ) :
            (
                <LoadingSection />
            );
    }
}

PayrollLoanRequestStepOne.propTypes = {
    formHandlers: PropTypes.object.isRequired,
    getInstallment: PropTypes.func.isRequired,
    getLoansForExpenses: PropTypes.func.isRequired,
    getPersonalInformation: PropTypes.func.isRequired,
    immContractLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    initialize: PropTypes.func.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    resetCheckboxCirbe: PropTypes.func.isRequired,
    resetMinTermMaxAmount: PropTypes.func.isRequired,
    setCirbeCheck: PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    simulationToken: PropTypes.string,
    stepPreApproval: PropTypes.number.isRequired,
    taeTooltip: PropTypes.object.isRequired
};

module.exports = PayrollLoanRequestStepOne;
